import { DEFAULT_GATE_DURATION, GateMotion, getGatePosition, getGateRemainingTime, getGateTargetPosition, isGateMoving, parseStateAt } from 'containers/Warehouses/gateMotion'
import { CSSProperties, useEffect, useState } from 'react'

export const GATE_TRAVEL = 364
const STOP_TRANSITION = 200

const useGateTransform = (input: GateMotion): CSSProperties => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let second = 0
    const first = requestAnimationFrame(() => {
      second = requestAnimationFrame(() => setReady(true))
    })
    return () => {
      cancelAnimationFrame(first)
      cancelAnimationFrame(second)
    }
  }, [])

  const now = Date.now()
  const motion: GateMotion = input.since === undefined && input.stateAt
    ? { ...input, since: parseStateAt(input.stateAt, now) }
    : input
  const moving = isGateMoving(motion.state)
  const hasMotionData = motion.since !== undefined

  const current = hasMotionData ? getGatePosition(motion, now) : getGatePosition({ state: motion.state })

  if (!ready) {
    return {
      transform: `translateX(${current * GATE_TRAVEL}px)`,
      transitionDuration: '0ms',
    }
  }

  const target = getGateTargetPosition(motion, now)
  const duration = moving
    ? (hasMotionData ? getGateRemainingTime(motion, now) : (motion.duration ?? DEFAULT_GATE_DURATION))
    : STOP_TRANSITION

  return {
    transform: `translateX(${target * GATE_TRAVEL}px)`,
    transitionDuration: `${Math.round(duration)}ms`,
  }
}

export default useGateTransform
